import React from 'react'
import { useTranslation } from 'react-i18next'
import { KibButtonNew } from '@chewy/kib-controls-react'
import { KibModal } from '@chewy/kib-overlays-react'

import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'
import '@chewy/kib-overlays-styles/dist/styles/kib-modal.css'

export interface NoAudioDetectedModalProps {
  onClose?: () => void
  onContinueRecording?: () => void
  onEndRecording?: () => void
  open: boolean
}

const NoAudioDetectedModal = ({
  open,
  onClose,
  onContinueRecording,
  onEndRecording,
}: NoAudioDetectedModalProps) => {
  const { t } = useTranslation(['Dialogs', 'Common'])

  const handleContinue = () => {
    onContinueRecording?.()
    onClose?.()
  }

  const handleEnd = () => {
    onEndRecording?.()
    onClose?.()
  }

  const controls = () => (
    <>
      {onContinueRecording && (
        <KibButtonNew
          emphasis="tertiary"
          theme="action"
          onClick={handleContinue}
        >
          {t(
            'AUDIO_RECORDER.NO_AUDIO_DETECTED_MODAL.CONTINUE_RECORDING_BUTTON',
          )}
        </KibButtonNew>
      )}
      {onEndRecording && (
        <KibButtonNew theme="destructive" onClick={handleEnd}>
          {t('AUDIO_RECORDER.NO_AUDIO_DETECTED_MODAL.END_RECORDING_BUTTON')}
        </KibButtonNew>
      )}
    </>
  )

  return (
    <KibModal
      controls={controls}
      open={open}
      title={t('AUDIO_RECORDER.NO_AUDIO_DETECTED_MODAL.TITLE')}
      onClose={onClose}
    >
      <p>{t('AUDIO_RECORDER.NO_AUDIO_DETECTED_MODAL.MESSAGE')}</p>
      <p>
        {t('AUDIO_RECORDER.NO_AUDIO_DETECTED_MODAL.TROUBLESHOOT_PREFIX')}{' '}
        {t('AUDIO_RECORDER.NO_AUDIO_DETECTED_MODAL.TROUBLESHOOT_SUFFIX')}
      </p>
    </KibModal>
  )
}

export default NoAudioDetectedModal
